import PageHero from "@/components/shared/PageHero";
import AboutSection from "@/components/sections/AboutSection";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function AboutMePage() {
  return (
    <div data-testid="page-about-me">
      <PageHero
        eyebrow="About Me"
        title={<>The story behind <span className="italic text-bronze">A Homely Abode.</span></>}
        sub="A patient, methodical Singapore real estate consultant who believes your property should be part of your financial future — not just a home."
        image={ASSETS.portraits.about}
        ctas={[
          { label: "WhatsApp Kiap", href: BRAND.whatsapp, variant: "primary" },
          { label: "View Services", to: "/why-me/services", variant: "secondary" },
        ]}
      />
      <AboutSection />
      <CTASection />
    </div>
  );
}
